<template>
  <div>
    <custom-btn-dialog
      :btn-text="generateMessage('tech_search.transmit')"
      v-if="isMobileUser && phoneType === 'SPH'"
      width="600px"
      ref="dialog"
      color="info"
      :title="generateMessage('requests.actions.transmission')"
      @change="getCustomerComment"
      :icon="icon"
    >
      <loader :is-loading="isLoading">
        <v-snackbar centered :color="snackbar.color" v-model="snackbar.open">
          {{ snackbar.message }}
        </v-snackbar>
        {{ generateMessage('tech_search.affected_tech_message') }}
        {{ name }}
        <custom-text-area
          class="mx-2"
          v-model="text"
          :max-character="1023"
          :error-too-long-msg="generateMessage('tech_search.comment_too_long')"
          :label="generateMessage('requests.fields.customer_comment')"
        />
        {{ generateMessage('tech_search.transmit_question') }}
      </loader>
      <template v-slot:actions>
        <v-btn
          small
          :disabled="textTooLong"
          color="info"
          class="mx-2"
          :loading="isUploading"
          @click="transmit"
        >
          {{ generateMessage('requests.actions.yes') }}
        </v-btn>
        <v-btn small class="mx-2" @click="cancel">
          {{ generateMessage('requests.actions.no') }}
        </v-btn>
      </template>
    </custom-btn-dialog>
    <v-btn v-else disabled small text color="info" class="d-flex justify-start">
      <v-icon left>{{ icon }}</v-icon>
      {{ generateMessage('tech_search.transmit') }}
    </v-btn>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import CustomBtnDialog from '@/components/dialogs/CustomBtnDialog';
import CustomTextArea from '@/components/CustomTextArea';

import { transmitAffectation } from '@/services/api/internal/requestActions/affectation.api';
import Loader from '@/components/widgets/Loader';
import snackbar from '@/business/mixins/snackbar';
import { LightRequestsService } from '@/services/services/requests.service';

export default {
  name: 'TransmitDialog',
  components: {
    Loader,
    CustomBtnDialog,
    CustomTextArea,
  },
  mixins: [snackbar],
  props: {
    isMobileUser: {
      type: Boolean,
      required: false,
    },
    phoneType: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    requestId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    generateMessage,
    transmitAffectation,
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    getCustomerComment() {
      this.isLoading = true;
      LightRequestsService.getCurrent(this.requestId)
        .then((request) => {
          this.text = request.customer_comment || '';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async transmit() {
      this.isUploading = true;
      this.transmitAffectation(this.requestId, this.text)
        .then(() => {
          this.$refs.dialog.handleCloseClick();
          this.$store.dispatch('requests/refreshItems');
          this.$store.dispatch('requests/removeCurrent', this.requestId);
          this.$store.dispatch('boilerplate/setModalClosed');
          this.$emit('success');
        })
        .catch((error) => {
          if (error.response.status === 409)
            this.sendMessage(
              'error',
              this.generateMessage('tech_search.already_transmitted')
            );
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
  },
  computed: {
    textTooLong() {
      return this.text && this.text.length > 1023;
    },
  },
  data() {
    return {
      isLoading: false,
      text: '',
      isUploading: false,
    };
  },
};
</script>
